/**
 * Count words for trial banners. Russian uses one/few/many; other locales use one/many.
 */
export function pluralForm(locale, count, forms) {
  const n = Math.abs(Math.trunc(Number(count) || 0));
  if (locale === "ru") {
    const mod100 = n % 100;
    const mod10 = n % 10;
    if (mod100 > 10 && mod100 < 20) return forms.many;
    if (mod10 === 1) return forms.one;
    if (mod10 >= 2 && mod10 <= 4) return forms.few || forms.many;
    return forms.many;
  }
  return n === 1 ? forms.one : forms.many;
}

export function trialQuotaSentence(t, locale, { days, remaining, blocked }) {
  const dayWord = pluralForm(locale, days, {
    one: t("unit.day.one"),
    few: t("unit.day.few"),
    many: t("unit.day.many"),
  });
  const daysPart = t("query.trialDaysLeft")
    .replace("{days}", String(days))
    .replace("{daysLabel}", dayWord);
  const left = Number(remaining) || 0;
  if (left <= 0) {
    const key = blocked ? "query.trialLimitReached" : "query.trialCaseUsed";
    return `${daysPart} · ${t(key)}`;
  }
  const caseWord = pluralForm(locale, left, {
    one: t("unit.case.one"),
    few: t("unit.case.few"),
    many: t("unit.case.many"),
  });
  const casesPart = t("query.trialCasesLeft")
    .replace("{remaining}", String(left))
    .replace("{casesLabel}", caseWord);
  return `${daysPart} · ${casesPart}`;
}

export function trialTodaySentence(t, locale, remaining) {
  const left = Number(remaining) || 0;
  if (left <= 0) return t("query.trialLimitReached");
  const caseWord = pluralForm(locale, left, {
    one: t("unit.case.one"),
    few: t("unit.case.few"),
    many: t("unit.case.many"),
  });
  return t("query.trialCasesLeft")
    .replace("{remaining}", String(left))
    .replace("{casesLabel}", caseWord);
}
